import { server, web } from "../db/api";

export async function loginHP(body) {
  console.log("SERVER HTTTP LOGIN : ", server);
  const res = await fetch(`${server}${web}/login`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body)
  });
  const response = await res.json();
  console.log("--ClienteHelper.loginHP-- response: ", response);
  return response;
}

export async function newClienteHP(body) {
  console.log("--ClienteHelper.newClienteHP-- body: ", JSON.stringify(body));

  const res = await fetch(`${server}${web}/register`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body)
  });
  const objeto = await res.json();
  console.log("--ClienteHelper.newClienteHP-- objeto: ", objeto);
  return objeto;
}

export async function getClienteHP(params) {
  const res = await fetch(`${server}${web}/get-user/${params}`, {
    method: "GET",
    headers: { "content-type": "application/json" }
  });
  const objeto = await res.json();
  const cliente = objeto.data;
  return cliente;
}

export const updateClienteHP = async body => {
  console.log("--ClienteHelper.updateClienteHP-- body: ", JSON.stringify(body));
  const res = await fetch(`${server}${web}/udpclienteweb`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body)
  });
  const update = await res.json();
  const response = update.db
  console.log("--ClienteHelper.updateClienteHP-- update: ", update);
  return update;
};

export const recoverPasswordHP = async body => {
  console.log("--ClienteHelper.recoverPassword-- body: ", body);
  const res = await fetch(`${server}${web}/user/resetpass`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body)
  });
  const response = await res.json();
  return response;
}

export const validateEmailHP = async body => {
  console.log("--ClienteHelper.validateEmail-- body: ", body);
  const res = await fetch(`${server}${web}/user/verifyemail`, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body)
  });
  const response = await res.json();
  return response;
}

export const validateLocationHP = async (id) => {
  console.log("--ClienteHelper.validateLocationHP-- id: ", id);
  const res = await fetch(`${server}${web}//get-locations/${id}`, {
    method: "GET",
    headers: { "content-type": "application/json" },
  });
  const response = await res.json();
  return response.data;



}
